import type { ReactNode } from 'react';
import { Icon } from '@capsico/ui';
import { Button, Field, Notice } from './ui';

/** Not-delivering-here state with the "Bring Capsico here" vote (guests may leave a phone). */
export function AreaVoteCard({
  labels,
  votesNearby,
  showPhone,
  phone,
  onPhone,
  onVote,
  voting,
  result,
  error,
  check,
  onOtherPlace,
}: {
  labels: {
    title: string;
    body: string;
    cta: string;
    voted: string;
    already: string;
    nearby: (count: number) => string;
    notify: string;
    otherPlace: string;
  };
  votesNearby: number | null;
  showPhone: boolean;
  phone: string;
  onPhone: (value: string) => void;
  onVote: () => void;
  voting: boolean;
  result: { counted: boolean } | null;
  error: string | null;
  /** W25: the Turnstile check (browser builds only), shown above the vote button. */
  check?: ReactNode;
  onOtherPlace: () => void;
}) {
  return (
    <div className="px-4 py-6">
      <div className="flex flex-col items-center text-center">
        <span className="inline-flex size-20 items-center justify-center rounded-full bg-brand-soft text-brand-ink">
          <Icon name="bike" size={36} />
        </span>
        <h2 className="mt-4 text-xl font-bold text-ink">{labels.title}</h2>
        <p className="mt-1 text-sm text-ink-2">{labels.body}</p>
        {votesNearby !== null && votesNearby > 0 && (
          <p className="mt-3 rounded-full bg-brand-soft px-3 py-1 text-xs font-semibold text-brand-ink tabular">
            {labels.nearby(votesNearby)}
          </p>
        )}
      </div>
      <div className="mt-6 space-y-3">
        {result ? (
          <Notice
            tone={result.counted ? 'positive' : 'info'}
            title={result.counted ? labels.voted : labels.already}
          />
        ) : (
          <>
            {showPhone && (
              <Field
                label={labels.notify}
                inputMode="tel"
                autoComplete="tel"
                value={phone}
                onChange={(event) => onPhone(event.target.value)}
                error={error}
              />
            )}
            {!showPhone && error && <p className="text-xs text-negative">{error}</p>}
            {check}
            <Button full busy={voting} onClick={onVote}>
              {labels.cta}
            </Button>
          </>
        )}
        <Button full tone="ghost" onClick={onOtherPlace}>
          {labels.otherPlace}
        </Button>
      </div>
    </div>
  );
}
